import { useEffect, useState } from "react";

/** Phones: below Tailwind's `sm` breakpoint (640 px), where the top bar folds up. */
export const PHONE = "(max-width: 639px)";

/** Whether a CSS media query matches now; follows changes (rotation, resizing). */
export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const change = () => setMatches(media.matches);
    media.addEventListener("change", change);
    change();
    return () => media.removeEventListener("change", change);
  }, [query]);
  return matches;
}
